/**
 * Generic sorting function by any property
 * @param {Array} items - Array of objects to sort
 * @param {string} property - Property name to sort by
 * @param {string} direction - 'asc' or 'desc' (default: 'asc')
 * @returns {Array} - Sorted array
 */
export const sortBy = (items, property, direction = 'asc') => {
  if (!Array.isArray(items)) {
    return []
  }

  return [...items].sort((a, b) => {
    const valueA = a[property]
    const valueB = b[property]

    if (direction === 'desc') {
      return valueB - valueA
    }

    return valueA - valueB
  })
}
